<template>
  <nav :class="$style['dataListGroupWrap']">
    <mds-list-group has-collapsible-child container v-if="ToggleRequired">
      <mds-list-group-item
        :text="headingtext"
        bold
        collapsible
        :expanded="expanded"
        @click.native="expanded = !expanded"
      >
        <template #mds-list-item-children>
          <div>
            <div
              :class="[
                $style['mds-list-group-item__main'],
                $style['dataListGroup'],
              ]"
              v-for="(item, index) in listdata"
              @click.stop
            >
              <div :class="$style['mds-list-group-item__upper']">
                <span :class="$style['mds-list-group-item__text']">
                  {{ item.label }}
                </span>
              </div>
              <div :class="$style['mds-list-group-item__lower']">
                <div :class="$style['mds-list-group-item__metadata-below']">
                  <span
                    :class="[
                      $style['mds-list-group-item__metadata-below-item'],
                      $style['dataListLabel'],
                    ]"
                    v-for="(int, ind) in item.data"
                  >
                    {{ int }}
                  </span>

                  <a href="#">
                    <mds-icon
                      :class="$style['dataListEditIcon']"
                      v-if="editbuttonvisible"
                      name="pencil"
                      size="small"
                      @click.native="EditData(item)"
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </template>
      </mds-list-group-item>
    </mds-list-group>

    <div v-if="!ToggleRequired">
      <div
        :class="[$style['mds-list-group-item__main'], $style['dataListGroup']]"
        v-for="(item, index) in listdata"
        @click.stop
      >
        <div :class="$style['mds-list-group-item__upper']">
          <span :class="$style['mds-list-group-item__text']">
            {{ item.label }}
          </span>
        </div>
        <div :class="$style['mds-list-group-item__lower']">
          <div :class="$style['mds-list-group-item__metadata-below']">
            <span
              :class="[
                $style['mds-list-group-item__metadata-below-item'],
                $style['dataListLabel'],
              ]"
              v-for="(int, ind) in item.data"
            >
              {{ int }}
            </span>

            <a href="#">
              <mds-icon
                :class="$style['dataListEditIcon']"
                v-if="editbuttonvisible"
                name="pencil"
                size="small"
                @click.native="EditData(item)"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import MdsIcon from "@mds/icon";
import MdsSection from "@mds/section";
import { head } from "lodash";
import parseJson from "parse-json";
export default {
  name: "AdlDataList",
  components: {
    MdsListGroup,
    MdsListGroupItem,
    MdsSection,
    MdsIcon,
  },
  props: {
    headingtext: String,
    listdata: Array,
    editbuttonvisible: Boolean,
    ToggleRequired: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      expanded: true,
    };
  },
  methods: {
    EditData(data) {
      this.$emit("OnEdit", data);
    },
  },
};
</script>
<style scoped lang="scss" module>
@import "./data-list.scss";

.dataListLabel {
  font-weight: bold;
  color: $mds-text-color-primary !important;
}

.dataListGroup + .dataListGroup {
  border-top: $mds-border-separator;
  padding-top: $mds-space-1-x;
  margin-top: $mds-space-1-x;
}

.dataListGroupWrap {
  border: $mds-border-separator-on-light;
  padding: $mds-space-1-and-a-half-x;
  border-radius: $mds-space-1-x;
  background-color: $mds-background-color-white;
}

.dataListEditIcon {
  float: right;
  opacity: 0;
}

.dataListGroup:hover .dataListEditIcon {
  opacity: 1;
}
</style>
